import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const images = {
    background_tile: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/background_tile.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/optimized/background_tile.webp`,
        width: 1807,
        height: 1995,
    },
    book: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/book.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/optimized/book.webp`,
        width: 1796,
        height: 1932,
    },
    globe: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/globe.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/optimized/globe.webp`,
        width: 1897,
        height: 2333,
    },
    music: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/music.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/optimized/music.webp`,
        width: 2061,
        height: 1065,
    },
    paints: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/paints.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/optimized/paints.webp`,
        width: 1810,
        height: 2444,
    },
    pencil: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/pencil.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/optimized/pencil.webp`,
        width: 1378,
        height: 1146,
    },
    planet: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/planet.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/optimized/planet.webp`,
        width: 1764,
        height: 1168,
    },
    "thanks_teacher_banner--1595x623": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/thanks_teacher_banner--1595x623.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/school-spirit/optimized/thanks_teacher_banner--1595x623.webp`,
        width: 1595,
        height: 623,
    },
};
const sceneTransition = {
    variant: "fade",
    timing: {
        variant: "linear",
        easing: "easeOut",
        durationSeconds: 1,
    },
};
export const schoolSpirit = {
    version: 1,
    themeId: "school-spirit",
    name: "School Spirit",
    endFadeDuration: 1,
    thumbnailFrame: 100,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/school-spirit.webp`,
    background: [
        {
            variant: "infinite-scroll",
            images: [
                {
                    src: images["background_tile"],
                    repeat: "repeat",
                    movePerSecond: {
                        x: 100,
                        y: 50,
                    },
                },
            ],
        },
        {
            variant: "color-series",
            colors: [
                "#f05229d0", // red
                "#4f7f48d0", // green
                "#45658dd0", // blue
                "#26211cd0", // dark brown
            ],
            skipNumSubScenes: 1,
            transition: sceneTransition,
        },
    ],
    scenes: [
        {
            type: "schoolSpiritIntro",
            durationSeconds: 9,
            faceCollage: {
                variant: "school-spirit",
                borderShape: "circle",
                borderWidth: 12,
            },
            bannerImage: {
                url: images["thanks_teacher_banner--1595x623"],
            },
        },
        {
            type: "greetingLinesAsScenes",
            variant: "intro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            showLogo: true,
        },
        {
            type: "clip-series-basic",
            showLogo: true,
        },
        {
            type: "greetingLinesAsScenes",
            variant: "outro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
        },
        {
            type: "outro",
            colorVariant: "lightBlue",
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "#cb6a59",
            fontFamily: "Kalnia Thin",
            fontWeight: "semibold",
            fontSize: 120,
            leading: 1.3,
            tracking: 0,
        },
        clips: {
            textVariant: {
                variant: "slide-in-static",
                entranceVariant: "slide-to-flush-left",
                startOffsetSeconds: 0.6,
                preserveHeightForEmptySubtitles: true,
                cards: [
                    {
                        backgroundColor: "#4f7f48",
                        backgroundOpacity: 1,
                        paddingLeft: "4rem",
                        paddingRight: "8rem",
                        doodleImages: [
                            {
                                url: images["paints"],
                                displaySize: {
                                    width: 130,
                                },
                                overflow: "visible",
                                style: {
                                    bottom: "50px",
                                    right: "-70px",
                                    transform: "rotate(20deg)",
                                },
                            },
                            {
                                url: images["music"],
                                displaySize: {
                                    width: 150,
                                },
                                overflow: "visible",
                                style: {
                                    bottom: "10px",
                                    right: "-70px",
                                    transform: "rotate(-20deg)",
                                },
                            },
                        ],
                    },
                    {
                        backgroundColor: "#4f7f48",
                        backgroundOpacity: 1,
                        paddingLeft: "4rem",
                        paddingRight: "8rem",
                        doodleImages: [
                            {
                                url: images["planet"],
                                displaySize: {
                                    width: 130,
                                },
                                overflow: "visible",
                                style: {
                                    top: "10px",
                                    right: "-50px",
                                    transform: "rotate(-20deg)",
                                },
                            },
                            {
                                url: images["globe"],
                                displaySize: {
                                    width: 110,
                                },
                                overflow: "visible",
                                style: {
                                    bottom: "-10px",
                                    right: "-70px",
                                    transform: "rotate(20deg)",
                                },
                            },
                        ],
                    },
                    {
                        backgroundColor: "#4f7f48",
                        backgroundOpacity: 1,
                        paddingLeft: "4rem",
                        paddingRight: "8rem",
                        doodleImages: [
                            {
                                url: images["pencil"],
                                displaySize: {
                                    width: 100,
                                },
                                overflow: "visible",
                                style: {
                                    top: "10px",
                                    right: "-50px",
                                    transform: "rotate(-100deg)",
                                },
                            },
                            {
                                url: images["book"],
                                displaySize: {
                                    width: 130,
                                },
                                overflow: "visible",
                                style: {
                                    bottom: "-10px",
                                    right: "-50px",
                                    transform: "rotate(20deg)",
                                },
                            },
                        ],
                    },
                ],
            },
            betweenTransition: sceneTransition,
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 1,
                textColor: "#cb6a59",
                fontFamily: "Kalnia Thin",
                fontWeight: "semibold",
                fontSize: 70,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#fff",
                backgroundOpacity: 1,
                textColor: "#cb6a59",
                fontFamily: "Kalnia Thin",
                fontWeight: "semibold",
                fontSize: 40,
                nudge: 2,
                textTransform: "uppercase",
            },
            scaleFactor: 0.9,
            borderRadius: "3rem",
            boxShadow: "0.25rem 0.25rem 1.125rem 0px rgba(0,0,0,0.75)",
            border: "0.25rem solid #232626",
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition,
    },
    colorPalettes: ["SchoolSpirit"],
};
